import React, { useEffect } from 'react';
import { useGlobalContext } from '../../Context';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { skills } from '../../data';
import './Skills.scss';
import HoverDiv from '../misc/HoverDiv';

gsap.registerPlugin(ScrollTrigger);

function Skills() {
  const { setIsHovered, hoveredDiv } = useGlobalContext();

  useEffect(() => {
    let tl = gsap.timeline({
      ease: 'power0',
      scrollTrigger: {
        trigger: '.skill-list',
        start: 'top 75%',
        end: 'bottom 25%',
        toggleActions: 'play',
      },
    });

    tl.from('.skills h1', {
      y: '-14vw',
      duration: 1,
    }).from('.skill-list div', {
      duration: 0.8,
      scale: 1.2,
      opacity: 0,
      y: -90,
      stagger: {
        from: 'center',
        amount: 1.5,
      },
    });
  }, []);

  function dragStart(e) {
    e.target.classList.add('dragging');
    e.dataTransfer.setData('text/plain', e.target.id);
    e.dataTransfer.dropEffect = 'copy';
    hoveredDiv.current.style.opacity = 0;
  }
  function drop(e) {
    e.preventDefault();
    hoveredDiv.current.style.opacity = 1;

    let draggableId = e.dataTransfer.getData('text');
    let droppable = e.currentTarget;
    let draggable = document.getElementById(draggableId);
    draggable.classList.remove('dragging');
    let droppableArea = window.getComputedStyle(droppable).gridArea;
    let draggableArea = window.getComputedStyle(draggable).gridArea;
    draggable.style.gridArea = droppableArea;
    droppable.style.gridArea = draggableArea;
  }

  function dragover(e) {
    e.preventDefault();
  }

  function showHover(e) {
    setIsHovered(true);
    hoveredDiv.current.style.opacity = 1;

    // const top = e.target.getBoundingClientRect().top;
    // const left = e.target.getBoundingClientRect().left;
    // const right = e.target.getBoundingClientRect().right;
    // const center = (left + right) / 2;

    // console.log(window.innerWidth);
    // if (window.innerWidth <= 600) {
    //   hoveredDiv.current.style.top = top - 140 + 'px';
    //   hoveredDiv.current.style.left = center - 90 + 'px';
    //   console.log('dumass');
    // } else if (window.innerWidth <= 750) {
    //   hoveredDiv.current.style.top = top - 160 + 'px';
    //   hoveredDiv.current.style.left = center - 110 + 'px';
    // } else if (window.innerWidth > 751) {
    //   hoveredDiv.current.style.top = top - 190 + 'px';
    //   hoveredDiv.current.style.left = center - 110 + 'px';
    //   console.log('dum');
    // }
  }

  function hideHover() {
    setIsHovered(false);
    hoveredDiv.current.style.opacity = 0;
  }

  function moveHover(e) {
    let x = e.clientX;
    let y = e.clientY;
    console.log(x);

    hoveredDiv.current.style.top = y - 180 + 'px';
    hoveredDiv.current.style.left = x + 'px';
  }

  return (
    <section className="skills">
      <div className="box">
        <h1>
          My Skills and Tools <hr />
        </h1>
      </div>
      <p className="desc">
        I always use all of these in every project , except for node, because i
        still aim my focus on Front-end.
      </p>
      <article className="skill-list">
        {skills.map((skill, i) => {
          return (
            <div
              id={skill.name}
              className={`editable ${skill.name}`}
              key={i}
              onMouseOver={showHover}
              onMouseOut={hideHover}
              onMouseMove={moveHover}
              draggable="true"
              onDragStart={dragStart}
              onDragOver={dragover}
              onDrop={drop}
              style={{ gridArea: skill.grid }}
            >
              <p>{skill.icon}</p>
              <p>{skill.name} </p>
            </div>
          );
        })}
        <HoverDiv />
      </article>
    </section>
  );
}

export default Skills;
